import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const ContractorDtoSchema = z.object({
  id: z.number(),
  fullName: z.string(),
});

const GetContractorsResponseDtoSchema = z.array(ContractorDtoSchema);

export type ContractorDto = z.infer<typeof ContractorDtoSchema>;
export type GetContractorsResponseDto = z.infer<
  typeof GetContractorsResponseDtoSchema
>;

export const getContractors = (config?: AxiosRequestConfig) => {
  return api
    .get('/users/contractors', config)
    .then(responseContract(GetContractorsResponseDtoSchema));
};
